import { Program as ProgramModel } from '@models/membership/Program'
import { useAppSelector } from '@store/hooks'
import { selectProgramById } from '@store/membership/ProgramReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Tag } from 'antd'
import { AvatarProps } from 'antd/es/avatar'
import { FC } from 'react'

type Variant = 'default' | 'purple'

type Props = SBModelComponent<ProgramModel> & {
  size?: AvatarProps['size']
  variant?: Variant
}

const PURPLE_STYLE = {
  backgroundColor: '#f9f0ff',
  color: '#722ed1',
  border: 'none',
  borderRadius: 4,
  padding: '1px 8px',
  fontSize: 10,
  lineHeight: '16px',
  margin: 0,
}

const ProgramTag: FC<Props> = ({ id, model, variant = 'default' }) => {
  const item = model ?? useAppSelector(selectProgramById(id!))

  if (!item) {
    return <></>
  }

  if (variant === 'purple') {
    return <Tag style={PURPLE_STYLE}>{item.en.name}</Tag>
  }

  return <Tag>{item.en.name}</Tag>
}

type ProgramTagType = {
  Tag: typeof ProgramTag
}

export { ProgramTag, type ProgramTagType }
